// extracted by mini-css-extract-plugin
module.exports = {"Title":"Popup__Title_AA3lR","Contacts":"Popup__Contacts_pO6zs"};